import styled, { keyframes, css } from 'styled-components';
import { LAYERS, SIZE } from './sizes';
import { LABEL, BUTTON } from './base';
import { DEFAULT_FONT_FAMILY } from './constants';
// import { ActionBoxMainContainer } from '../features/Performance/styles';

const shake = keyframes`
    10%, 90% {
        transform: translate3d(-1px, 0, 0);
    }
    20%, 80% {
        transform: translate3d(2px, 0, 0);
    }
    30%, 50%, 70% {
        transform: translate3d(-4px, 0, 0);
    }
    40%, 60% {
        transform: translate3d(4px, 0, 0);
    }
`

export const shakeAnimation = () => css`
${shake} 0.6s;
`

export const FlexDiv = styled.div`
    display: flex;
`;

export const FullSizeFlexDiv = styled(FlexDiv)`
    height: 100%;
    width: 100%;
`;

export const CenteredFlexDiv = styled(FlexDiv)`
    justify-content: center;
    align-items: center;
`;

export const BannerTextContainer = styled.div`
    display:flex;
    padding: 0px ${SIZE.TWO}px;
    justify-content: space-between;
    flex:1;
`;

export const ButtonDismiss = styled(BUTTON)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: 1.3px;
    color: #b7c0d5;
    background: none;
    &:hover {
        text-shadow: 0 0 6px rgba(35, 173, 255, 1);
        cursor: pointer;
    }
`

export const BannerText = styled(LABEL)`
    color: white;
    padding: 0px ${SIZE.TWO}px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 12px;
    letter-spacing: 0.6px;
`

export interface ButtonWrapperProps {
    margin?: string
    padding?: string
    justifyContent?: string
    minWidth?: string
    maxWidth?: string
}
export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: ${(props: ButtonWrapperProps) => props.justifyContent ? props.justifyContent : 'center'};
    margin: ${(props: ButtonWrapperProps) => props.margin ? props.margin : ''};
    padding: ${(props: ButtonWrapperProps) => props.padding ? props.padding : ''};
    min-width: ${(props: ButtonWrapperProps) => props.minWidth ? props.minWidth : ''};
    max-width: ${(props: ButtonWrapperProps) => props.maxWidth ? props.maxWidth : ''};

    
`;

// ${ActionBoxMainContainer} & {
//     align-items: flex-end;
//     margin-bottom: ${SIZE.TWO}px;
// }

export const TCDefaultInput = styled.input`
    border: none;
    outline: none;
    padding-left: ${SIZE.ONE}px;
    width: 100%;
`;


export const ICON = styled.span`
    display: inline-block;
    font-weight:700;
    &:before{
        font-family: 'icomoon' !important;
        speak: none;
        
    };
`;
//content: "\\${props => props.iconCode}";

export const ModalTitle = styled(LABEL)`
    display: flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
`
export interface FieldWrapperProps {
    width: string
    margin: string
}
export const FieldWrapper = styled.div`
    display:flex;
    width: ${(props: FieldWrapperProps) => props.width};
    margin: ${(props: FieldWrapperProps) => props.margin};
`

export const POPUP_CONTAINER = styled.div`
    position: absolute;
    opacity:0;
    transition: 0.3s;
    visibility: hidden;
`

export const POPUP_TRIGGER = styled.span`
    transition: all 0.300s;
    &:hover > div {
        z-index: ${LAYERS.LAYER_4};
        visibility: visible;
        flex: 0 0 auto;
        opacity:1;
        transform: translateX(${SIZE.HALF}px);
    }
`

export const POPUP_TRIGGER_LEFT = styled(POPUP_TRIGGER)`
    &:hover > div {
        transform: translateX(${-SIZE.HALF}px);
    }
`

export const POPUP_TRIGGER_BOTTOM = styled(POPUP_TRIGGER)`
    &:hover > div {
        transform: translateY(${SIZE.ONE}px);
    }
`